import { useState, useEffect } from 'react';
import mapValues from 'lodash/fp/mapValues';
import isPlainObject from 'lodash/isPlainObject';
import any from 'lodash/fp/some';
import filter from 'lodash/fp/filter';
import toString from 'lodash/fp/toString';
import toLower from 'lodash/fp/toLower';
import compose from 'lodash/fp/compose';
import contains from 'lodash/fp/contains';
import identity from 'lodash/fp/identity';

const useSearch = data => {
  const [filteredData, setFilteredData] = useState(data);
  const [value, setSearchField] = useState('');

  useEffect(() => {
    const lowerString = compose(
      toLower,
      toString
    );

    const containsLowerValue = compose(
      contains,
      lowerString
    )(value);

    const liftObject = f => data => {
      if (!isPlainObject(data)) return f(data)
      return mapValues(liftObject(f))(data)
    };

    const fdata = liftObject(
      filter(
        compose(
          any(identity),
          mapValues(
            compose(
              containsLowerValue,
              lowerString
            )
          )
        )
      )
    );

    setFilteredData(fdata(data));
  }, [data, value]);

  const onChange = event => setSearchField(event.target.value);
  const clearSearch = () => setSearchField('');

  return [
    {
      value,
      onChange,
    },
    clearSearch,
    filteredData
  ];
};

export default useSearch;
